// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import { _reducer as outcomesBonus } from './outcomesBonus.reducers';
import outcomesBonusEpics from './outcomesBonus.epics';

export const reducer = combineReducers({
  outcomesBonus,
});

export const epics = combineEpics(outcomesBonusEpics);

export * from './outcomesBonus.actions';
export * from './outcomesBonus.selectors';
